/* eslint-disable react/destructuring-assignment */
import React, { useMemo, useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import messages from 'aurora-translations';
import styles from './styles';

function CheckboxGroup(props) {
  const { classes, title, onChange } = props;
  const [expanded, setExpanded] = useState(false);
  const [values, setValues] = useState(props.values || []);

  useEffect(() => {
    onChange && onChange(values);
  }, [values]);

  const handleCheck = useCallback(
    (event, id) => {
      const { checked } = event.target;
      const newValues = values.map(val => {
        if (val.id === id) return { ...val, checked };
        return val;
      });
      setValues(newValues);
    },
    [values],
  );

  const handleCheckAll = useCallback(
    event => {
      const { checked } = event.target;
      const newValue = values.map(val => ({ ...val, checked }));
      setValues(newValue);
    },
    [values],
  );

  const isAllChecked = useMemo(() => {
    for (let i = 0; i < values.length; i += 1) {
      if (!values[i].checked) return false;
    }
    return true;
  }, [values]);

  const getCount = useMemo(() => {
    const count = values.reduce((acc, val) => {
      if (val.checked) {
        const newAcc = acc + 1;
        return newAcc;
      }
      return acc;
    }, 0);

    if (count === values.length) return localStorage.getItem('lang') === 'ar' ? '(الجميع)' : '(All)';

    return count > 0 ? `(${count})` : null;
  }, [values]);

  return (
    <Accordion expanded={expanded}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        className={classNames(classes.accordionTitleHead, { [classes.borderBottom]: !expanded })}
        onClick={() => setExpanded(!expanded)}
      >
        <FormControlLabel
          value={isAllChecked}
          control={
            <Checkbox
              checked={isAllChecked}
              onChange={handleCheckAll}
              classes={{ root: classes.checkbox, checked: classes.checked }}
            />
          }
        />
        <Typography component='p'>
          {messages[title]?.id ? <FormattedMessage {...messages[title]} /> : title} <span>{getCount}</span>
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.accordianDetails}>
        <div className={classes.checkboxWrapper}>
          {values.map(val => (
            <div key={val.id} className={classes.checkboxContainer}>
              <FormControlLabel
                value={val.checked || ''}
                control={
                  <Checkbox
                    checked={val.checked}
                    onChange={e => handleCheck(e, val.id)}
                    name={val.label}
                    classes={{ root: classes.checkbox, checked: classes.checked }}
                  />
                }
                label={val.label}
              />
            </div>
          ))}
        </div>
      </AccordionDetails>
    </Accordion>
  );
}

CheckboxGroup.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  values: PropTypes.array.isRequired,
};

CheckboxGroup.defaultProps = {
  disabled: false,
};

export default withStyles(styles)(CheckboxGroup);
